import type {
  QuerySitesRequest,
  QuerySitesResponse,
} from "@wix/ambassador-site-list-v2-site/types";
import { querySites } from "@wix/ambassador-site-list-v2-site/http";
import type { IHttpClient } from "@wix/fe-essentials-standalone/dist/types/exports/http-client";
import { LOCAL_SERVER_BASE_URL } from "../../consts";
import type { PanoramaClient } from "@wix/panorama-client";
import { isFigmaFrame as isFigmaFrameApi } from "@wix/ambassador-picasso-serverless-service-v1-project-file/http";

export const getUserPicassoSites = async ({
  httpClient,
  options,
  panoramaClient,
}: {
  httpClient: IHttpClient;
  options: QuerySitesRequest;
  panoramaClient: PanoramaClient;
}): Promise<QuerySitesResponse> => {
  try {
    return httpClient.request(querySites(options)).then(({ data }) => ({
      sites: data?.sites,
      metadata: data?.metadata,
    }));
  } catch (error: any) {
    panoramaClient
      .errorMonitor({
        data: { tags: { feature: "get-user-picasso-sites" } },
      })
      .reportError(new Error(`Failed to get user picasso sites: ${error}`));
    return {
      sites: [],
      metadata: {
        count: 0,
      },
    };
  }
};

export const getProjects = async ({
  httpClient,
  msid,
}: {
  httpClient: IHttpClient;
  msid: string;
}): Promise<AnyFixMe> => {
  const res = await httpClient.get(
    `${LOCAL_SERVER_BASE_URL}/api/getProjects?msid=${msid}`,
  );
  return res.data;
};

export const isFigmaFrame = async ({
  httpClient,
  url,
}: {
  httpClient: IHttpClient;
  url: string;
}): Promise<boolean> => {
  try {
    const res = await httpClient.request(isFigmaFrameApi({ figmaUrl: url }));
    return res.data?.frame ?? false;
  } catch (error) {
    return false;
  }
};
